<template>
  <div class="app-container">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox"  class="formBox margbot">
          <el-form :inline="true" class="demo-form-inline" label-width="110px" style="width: 100%;"
        size="mini">
        <div class="formItemBox">
            <el-form-item label="货主委托单号：">
              <el-input v-model="formData.customerNoticeNo" size="mini"  placeholder="请输入货主委托单号">
              </el-input>
            </el-form-item>
            <el-form-item label="加工单编号：">
              <el-input v-model="formData.processingNo" size="mini"  placeholder="请输入加工单编号">
              </el-input>
            </el-form-item>
            <el-form-item label="原料捆包号：">
              <el-input v-model="formData.cargoBarcodes" size="mini"  placeholder="请输入原料捆包号">
              </el-input>
            </el-form-item>
            <el-form-item label="成品捆包号：">
              <el-input v-model="formData.cargoBarcode" size="mini"  placeholder="请输入成品捆包号">
              </el-input>
            </el-form-item>
            <el-form-item label="货主：">
              <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable>
                <el-option v-for="(item,index) in HZData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="制单日期：">
              <div style="display: flex;">
              <el-date-picker v-model="formData.matchingDateStart" size="mini" type="date" placeholder="选择制单日期"
                value-format="yyyy-MM-dd"></el-date-picker>
              -
              <el-date-picker v-model="formData.matchingDateEnd" size="mini" placeholder="选择制单日期" type="date"
                value-format="yyyy-MM-dd"></el-date-picker>
              </div>
            </el-form-item>
            </div>
            <el-form-item>
              <el-button type="primary" @click="chaxun">
                查询
              </el-button>
              <el-button type="primary" @click="daochu" :disabled="isDisable">
                导出
              </el-button>
              <el-button type="primary" @click="chongzhi">
                重置
              </el-button>
            </el-form-item>
          </el-form>
      </div>
      <div :style="{height:h}">
        <el-table size="mini" height="100%" ref="tabref1" :data="tableData" style="width:100%"
          :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" class="tableComent"
          :header-cell-style="{background:'#F5F5F5',color:'black'}" highlight-current-row @row-click="dianjixuanzhong">
          <el-table-column type="index" align="center" label="序号" fixed width="60"></el-table-column>
          <el-table-column label="加工单编号" :show-overflow-tooltip="true" :width="260" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleClick(scope.row)">{{scope.row.processingNo}}</el-button>
            </template>
          </el-table-column>
          <el-table-column :width="160" label="货主委托单号" :show-overflow-tooltip="true" prop="customerNoticeNo"
            align="center"></el-table-column>
          <el-table-column label="货主" :show-overflow-tooltip="true" prop="customerName" align="center" :width="260">
          </el-table-column>
          <el-table-column label="加工类型" :show-overflow-tooltip="true" prop="processingTypeName" align="center">
          </el-table-column>
          <el-table-column label="制单人" :show-overflow-tooltip="true" prop="matchingPerson" align="center">
          </el-table-column>
          <el-table-column label="制单时间" :width="260" :show-overflow-tooltip="true" prop="matchingDate" align="center">
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pags" style="text-align: right;">
        <el-pagination background @current-change="handleCurrentChangeA" :current-page="current"
          :page-size="formData.pageSize" :page-sizes="[10, 20, 30, 40,50]"
          layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeA" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  getMachiningProductDetailList
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'

export default {
  data () {
    return {
      formData: {
        customerNoticeNo: '',
        processingNo: '',
        cargoBarcodes: '',
        cargoBarcode: '',
        customerTaxId: '',
        matchingDateStart: '',
        matchingDateEnd: '',
        pageNo: 1,
        pageSize: 20
      },
      // 分页
      current: 1,
      total: 0,
      // 货主选项列表
      HZData: [],
      tableData: [],
      h: '',
      isDisable: false
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - 46 - 115 - h) + 'px'
    this.getRelationCustomerS()
    this.getMachiningProductDetailListS(this.formData)
  },
  methods: {

    // 点击导出
    daochu () {
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 5000)
      let form = this.formData
      // delete form.pageNo
      // delete form.pageSize
      console.log(form)

      // fetch(

      exportExcel(
        this.global.wmsStockName +
          '/machiningReport/exportProductCheck',
        form,
        '加工成品明细表'
      )
    },
    // 点击加工单编号
    handleClick (row) {
      console.log(row.machiningEntrustId)
      console.log(row.machiningNoticeId)
      if (row.machiningEntrustId !== undefined) {
        this.$router.push({
          path: '/reportDetail',
          query: {
            machiningEntrustId: row.machiningEntrustId
          }
        })
      } else {
        this.$router.push({
          path: '/reportDetail',
          query: {
            machiningNoticeId: row.machiningNoticeId
          }
        })
      }
      // //         machiningEntrustId
      // // machiningNoticeId
      // this.$router.push({
      //   path: '/reportDetail',
      //   query: {
      //     machiningEntrustId: row.machiningEntrustId
      //   }
      // })
    },
    // 点击选中行
    dianjixuanzhong () {
      //
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.formData.pageNo = val
      this.getMachiningProductDetailListS(this.formData)
    },
    handleSizeChangeA (val) {
      this.formData.pageSize = val
      this.getMachiningProductDetailListS(this.formData)
    },
    // 查询
    chaxun () {
      this.getMachiningProductDetailListS(this.formData)
    },
    // 获取明细表
    getMachiningProductDetailListS (params) {
      getMachiningProductDetailList(params)
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 重置
    chongzhi () {
      this.formData.customerNoticeNo = ''
      this.formData.processingNo = ''
      this.formData.cargoBarcodes = ''
      this.formData.cargoBarcode = ''
      this.formData.customerTaxId = ''
      this.formData.matchingDateStart = ''
      this.formData.matchingDateEnd = ''
      this.getMachiningProductDetailListS(this.formData)
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({})
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    }
  }
}

</script>

<style lang="less" scoped>
  .chuKuZuoyeWarp {
    width: 100%;
    position: relative;
    height: 100%;
  }

  .demo-form-inline {
    margin-left: 10px;
  }

  .chuKuZuoyeWarp-body-queryIpt {
    width: 100%;
    display: flex;
    font-size: 14px;
  }

  .el-button,
  .el-checkbox {
    -webkit-user-select: auto;
    user-select: auto;
  }
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
